module.exports = __webpack_public_path__ + "static/media/ve.89aac662.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ve.svg
// module id = 970
// module chunks = 0